import PortImg1 from "../assets/images/resources/portDetailImg1-1.jpg";
import PortImg2 from "../assets/images/resources/portDetailImg1-2.jpg";
import PortImg3 from "../assets/images/resources/portDetailImg1-3.jpg";
import PortImg4 from "../assets/images/resources/portDetailImg1-4.jpg";
import PortImg5 from "../assets/images/resources/portDetailImg1-5.jpg";
import PortImg6 from "../assets/images/resources/portDetailImg1-6.jpg";
import PortImg7 from "../assets/images/resources/portDetailImg1-7.jpg";
// import PortImg8 from "../assets/images/resources/portDetailImg1-8.jpg";
// import PortImg9 from "../assets/images/resources/portDetailImg1-9.jpg";

export const portDetail = [
  {
    id: 1,
    portImg: PortImg1,
    portTitle: "Graphic Illustration",
    portComments: "35",
    portLikes: "40",
    portCateList: [
      {
        cateItem: "Design,",
        cateLink: "#",
      },
      {
        cateItem: "Events,",
        cateLink: "#",
      },
      {
        cateItem: "Technology",
        cateLink: "#",
      },
    ],
    portDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Home renovations, especially those involving plentiful of demolition can be a very dusty affair. The same is true as we experience the emotional sensation of stress from our first instances of social rejection ridicule. We quickly learn to fear and thus automatically avoid potentially stressful situations of all kinds of all making mistakes.",
    portDesc2:
      "Whether article spirits new her covered hastily sitting her. Money witty books nor son add. Chicken age had evening believe but proceed pretend mrs. At missed advice my it no sister. Miss told ham dull knew see she spot near can. Spirit her entire her called. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar.",
    portDesc3:
      "Objectively pursue diverse catalysts for change for interoperable meta-services. Distinctively re-engineer revolutionary meta-services and premium architectures. Intrinsically incubate intuitive opportunities and real-time potentialities. Appropriately communicate one-to-one technology.",
    portDesc4:
      "The advantage of its Latin origin and the relative meaninglessness of Lorum Ipsum is that the text does not attract attention to itself or distract the viewer's attention from the layout.",
    portTitle2: "What makes the best co-working space?",
    portInfoList: [
      {
        infoItem: "Website:",
        infoCap: "websroad.com",
      },
      {
        infoItem: "Date:",
        infoCap: "August 02, 2022",
      },
      {
        infoItem: "Services:",
        infoCap: "Design, Art Direction, Website",
      },
    ],
    portInfoList2: [
      {
        infoCap: "Quis Nostrud Exercitation Ullamco Laboris.",
      },
      {
        infoCap: "Ullamco Laboris Nisi Ut Aliquip.",
      },
      {
        infoCap: "Reprehenderit In Voluptate Velit.",
      },
      {
        infoCap: "Accusantium Doloremque Laudantium.",
      },
      {
        infoCap: "Voluptate Velit Esse Cillum.",
      },
    ],
  },
  {
    id: 2,
    portImg: PortImg2,
    portTitle: "Efficient Team Mobile",
    portComments: "34",
    portLikes: "20",
    portCateList: [
      {
        cateItem: "Design,",
        cateLink: "#",
      },
      {
        cateItem: "Events,",
        cateLink: "#",
      },
      {
        cateItem: "Technology",
        cateLink: "#",
      },
    ],
    portDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Home renovations, especially those involving plentiful of demolition can be a very dusty affair. The same is true as we experience the emotional sensation of stress from our first instances of social rejection ridicule. We quickly learn to fear and thus automatically avoid potentially stressful situations of all kinds of all making mistakes.",
    portDesc2:
      "Whether article spirits new her covered hastily sitting her. Money witty books nor son add. Chicken age had evening believe but proceed pretend mrs. At missed advice my it no sister. Miss told ham dull knew see she spot near can. Spirit her entire her called. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar.",
    portDesc3:
      "Objectively pursue diverse catalysts for change for interoperable meta-services. Distinctively re-engineer revolutionary meta-services and premium architectures. Intrinsically incubate intuitive opportunities and real-time potentialities. Appropriately communicate one-to-one technology.",
    portDesc4:
      "The advantage of its Latin origin and the relative meaninglessness of Lorum Ipsum is that the text does not attract attention to itself or distract the viewer's attention from the layout.",
    portTitle2: "What makes the best co-working space?",
    portInfoList: [
      {
        infoItem: "Website:",
        infoCap: "websroad.com",
      },
      {
        infoItem: "Date:",
        infoCap: "August 02, 2022",
      },
      {
        infoItem: "Services:",
        infoCap: "Design, Art Direction, Website",
      },
    ],
    portInfoList2: [
      {
        infoCap: "Quis Nostrud Exercitation Ullamco Laboris.",
      },
      {
        infoCap: "Ullamco Laboris Nisi Ut Aliquip.",
      },
      {
        infoCap: "Reprehenderit In Voluptate Velit.",
      },
      {
        infoCap: "Accusantium Doloremque Laudantium.",
      },
      {
        infoCap: "Voluptate Velit Esse Cillum.",
      },
    ],
  },
  {
    id: 3,
    portImg: PortImg3,
    portTitle: "UI/UX Creative Design",
    portComments: "33",
    portLikes: "44",
    portCateList: [
      {
        cateItem: "Design,",
        cateLink: "#",
      },
      {
        cateItem: "Events,",
        cateLink: "#",
      },
      {
        cateItem: "Technology",
        cateLink: "#",
      },
    ],
    portDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Home renovations, especially those involving plentiful of demolition can be a very dusty affair. The same is true as we experience the emotional sensation of stress from our first instances of social rejection ridicule. We quickly learn to fear and thus automatically avoid potentially stressful situations of all kinds of all making mistakes.",
    portDesc2:
      "Whether article spirits new her covered hastily sitting her. Money witty books nor son add. Chicken age had evening believe but proceed pretend mrs. At missed advice my it no sister. Miss told ham dull knew see she spot near can. Spirit her entire her called. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar.",
    portDesc3:
      "Objectively pursue diverse catalysts for change for interoperable meta-services. Distinctively re-engineer revolutionary meta-services and premium architectures. Intrinsically incubate intuitive opportunities and real-time potentialities. Appropriately communicate one-to-one technology.",
    portDesc4:
      "The advantage of its Latin origin and the relative meaninglessness of Lorum Ipsum is that the text does not attract attention to itself or distract the viewer's attention from the layout.",
    portTitle2: "What makes the best co-working space?",
    portInfoList: [
      {
        infoItem: "Website:",
        infoCap: "websroad.com",
      },
      {
        infoItem: "Date:",
        infoCap: "August 02, 2022",
      },
      {
        infoItem: "Services:",
        infoCap: "Design, Art Direction, Website",
      },
    ],
    portInfoList2: [
      {
        infoCap: "Quis Nostrud Exercitation Ullamco Laboris.",
      },
      {
        infoCap: "Ullamco Laboris Nisi Ut Aliquip.",
      },
      {
        infoCap: "Reprehenderit In Voluptate Velit.",
      },
      {
        infoCap: "Accusantium Doloremque Laudantium.",
      },
      {
        infoCap: "Voluptate Velit Esse Cillum.",
      },
    ],
  },
  {
    id: 4,
    portImg: PortImg4,
    portTitle: "Mobile Illustration",
    portComments: "54",
    portLikes: "40",
    portCateList: [
      {
        cateItem: "Design,",
        cateLink: "#",
      },
      {
        cateItem: "Events,",
        cateLink: "#",
      },
      {
        cateItem: "Technology",
        cateLink: "#",
      },
    ],
    portDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Home renovations, especially those involving plentiful of demolition can be a very dusty affair. The same is true as we experience the emotional sensation of stress from our first instances of social rejection ridicule. We quickly learn to fear and thus automatically avoid potentially stressful situations of all kinds of all making mistakes.",
    portDesc2:
      "Whether article spirits new her covered hastily sitting her. Money witty books nor son add. Chicken age had evening believe but proceed pretend mrs. At missed advice my it no sister. Miss told ham dull knew see she spot near can. Spirit her entire her called. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar.",
    portDesc3:
      "Objectively pursue diverse catalysts for change for interoperable meta-services. Distinctively re-engineer revolutionary meta-services and premium architectures. Intrinsically incubate intuitive opportunities and real-time potentialities. Appropriately communicate one-to-one technology.",
    portDesc4:
      "The advantage of its Latin origin and the relative meaninglessness of Lorum Ipsum is that the text does not attract attention to itself or distract the viewer's attention from the layout.",
    portTitle2: "What makes the best co-working space?",
    portInfoList: [
      {
        infoItem: "Website:",
        infoCap: "websroad.com",
      },
      {
        infoItem: "Date:",
        infoCap: "August 02, 2022",
      },
      {
        infoItem: "Services:",
        infoCap: "Design, Art Direction, Website",
      },
    ],
    portInfoList2: [
      {
        infoCap: "Quis Nostrud Exercitation Ullamco Laboris.",
      },
      {
        infoCap: "Ullamco Laboris Nisi Ut Aliquip.",
      },
      {
        infoCap: "Reprehenderit In Voluptate Velit.",
      },
      {
        infoCap: "Accusantium Doloremque Laudantium.",
      },
      {
        infoCap: "Voluptate Velit Esse Cillum.",
      },
    ],
  },
  {
    id: 5,
    portImg: PortImg5,
    portTitle: "Anaylsis Application",
    portComments: "12",
    portLikes: "16",
    portCateList: [
      {
        cateItem: "Design,",
        cateLink: "#",
      },
      {
        cateItem: "Events,",
        cateLink: "#",
      },
      {
        cateItem: "Technology",
        cateLink: "#",
      },
    ],
    portDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Home renovations, especially those involving plentiful of demolition can be a very dusty affair. The same is true as we experience the emotional sensation of stress from our first instances of social rejection ridicule. We quickly learn to fear and thus automatically avoid potentially stressful situations of all kinds of all making mistakes.",
    portDesc2:
      "Whether article spirits new her covered hastily sitting her. Money witty books nor son add. Chicken age had evening believe but proceed pretend mrs. At missed advice my it no sister. Miss told ham dull knew see she spot near can. Spirit her entire her called. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar.",
    portDesc3:
      "Objectively pursue diverse catalysts for change for interoperable meta-services. Distinctively re-engineer revolutionary meta-services and premium architectures. Intrinsically incubate intuitive opportunities and real-time potentialities. Appropriately communicate one-to-one technology.",
    portDesc4:
      "The advantage of its Latin origin and the relative meaninglessness of Lorum Ipsum is that the text does not attract attention to itself or distract the viewer's attention from the layout.",
    portTitle2: "What makes the best co-working space?",
    portInfoList: [
      {
        infoItem: "Website:",
        infoCap: "websroad.com",
      },
      {
        infoItem: "Date:",
        infoCap: "August 02, 2022",
      },
      {
        infoItem: "Services:",
        infoCap: "Design, Art Direction, Website",
      },
    ],
    portInfoList2: [
      {
        infoCap: "Quis Nostrud Exercitation Ullamco Laboris.",
      },
      {
        infoCap: "Ullamco Laboris Nisi Ut Aliquip.",
      },
      {
        infoCap: "Reprehenderit In Voluptate Velit.",
      },
      {
        infoCap: "Accusantium Doloremque Laudantium.",
      },
      {
        infoCap: "Voluptate Velit Esse Cillum.",
      },
    ],
  },
  {
    id: 6,
    portImg: PortImg6,
    portTitle: "Business Growth",
    portComments: "35",
    portLikes: "40",
    portCateList: [
      {
        cateItem: "Design,",
        cateLink: "#",
      },
      {
        cateItem: "Events,",
        cateLink: "#",
      },
      {
        cateItem: "Technology",
        cateLink: "#",
      },
    ],
    portDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Home renovations, especially those involving plentiful of demolition can be a very dusty affair. The same is true as we experience the emotional sensation of stress from our first instances of social rejection ridicule. We quickly learn to fear and thus automatically avoid potentially stressful situations of all kinds of all making mistakes.",
    portDesc2:
      "Whether article spirits new her covered hastily sitting her. Money witty books nor son add. Chicken age had evening believe but proceed pretend mrs. At missed advice my it no sister. Miss told ham dull knew see she spot near can. Spirit her entire her called. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar.",
    portDesc3:
      "Objectively pursue diverse catalysts for change for interoperable meta-services. Distinctively re-engineer revolutionary meta-services and premium architectures. Intrinsically incubate intuitive opportunities and real-time potentialities. Appropriately communicate one-to-one technology.",
    portDesc4:
      "The advantage of its Latin origin and the relative meaninglessness of Lorum Ipsum is that the text does not attract attention to itself or distract the viewer's attention from the layout.",
    portTitle2: "What makes the best co-working space?",
    portInfoList: [
      {
        infoItem: "Website:",
        infoCap: "websroad.com",
      },
      {
        infoItem: "Date:",
        infoCap: "August 02, 2022",
      },
      {
        infoItem: "Services:",
        infoCap: "Design, Art Direction, Website",
      },
    ],
    portInfoList2: [
      {
        infoCap: "Quis Nostrud Exercitation Ullamco Laboris.",
      },
      {
        infoCap: "Ullamco Laboris Nisi Ut Aliquip.",
      },
      {
        infoCap: "Reprehenderit In Voluptate Velit.",
      },
      {
        infoCap: "Accusantium Doloremque Laudantium.",
      },
      {
        infoCap: "Voluptate Velit Esse Cillum.",
      },
    ],
  },
  {
    id: 7,
    portImg: PortImg7,
    portTitle: "Profitable Business",
    portComments: "88",
    portLikes: "55",
    portCateList: [
      {
        cateItem: "Design,",
        cateLink: "#",
      },
      {
        cateItem: "Events,",
        cateLink: "#",
      },
      {
        cateItem: "Technology",
        cateLink: "#",
      },
    ],
    portDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Home renovations, especially those involving plentiful of demolition can be a very dusty affair. The same is true as we experience the emotional sensation of stress from our first instances of social rejection ridicule. We quickly learn to fear and thus automatically avoid potentially stressful situations of all kinds of all making mistakes.",
    portDesc2:
      "Whether article spirits new her covered hastily sitting her. Money witty books nor son add. Chicken age had evening believe but proceed pretend mrs. At missed advice my it no sister. Miss told ham dull knew see she spot near can. Spirit her entire her called. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar. Lorem ipsum dolor sit amet, consec tetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar.",
    portDesc3:
      "Objectively pursue diverse catalysts for change for interoperable meta-services. Distinctively re-engineer revolutionary meta-services and premium architectures. Intrinsically incubate intuitive opportunities and real-time potentialities. Appropriately communicate one-to-one technology.",
    portDesc4:
      "The advantage of its Latin origin and the relative meaninglessness of Lorum Ipsum is that the text does not attract attention to itself or distract the viewer's attention from the layout.",
    portTitle2: "What makes the best co-working space?",
    portInfoList: [
      {
        infoItem: "Website:",
        infoCap: "websroad.com",
      },
      {
        infoItem: "Date:",
        infoCap: "August 02, 2022",
      },
      {
        infoItem: "Services:",
        infoCap: "Design, Art Direction, Website",
      },
    ],
    portInfoList2: [
      {
        infoCap: "Quis Nostrud Exercitation Ullamco Laboris.",
      },
      {
        infoCap: "Ullamco Laboris Nisi Ut Aliquip.",
      },
      {
        infoCap: "Reprehenderit In Voluptate Velit.",
      },
      {
        infoCap: "Accusantium Doloremque Laudantium.",
      },
      {
        infoCap: "Voluptate Velit Esse Cillum.",
      },
    ],
  },
];
